import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, NavigationEnd, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth/auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
  ) {

  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.authService.checkSession('1').pipe(map((response: any) => {
      if (response && response.data) {
        if ((response.data?.email_verified == '0' && response.data?.office_email != '') || (response.data?.sms_verified == '0' && response.data?.mobile != '' && response.data?.country_code == '91')) {
          return true;
        } else if (response.data?.is_referral_pending == '1') {
          this.router.navigate(['setup'], { queryParams: {}, queryParamsHandling: 'merge' });
        } else if ((response.data?.force_update_password == '1') || (response.data?.sms_verified != '1' && response.data?.mobile != '') || (response.data?.email_verified != '1' && response.data?.office_email != '')) {
          this.redirectToLoginPage();
        } else {
          const auth_modules = response.data?.authorised_modules ? response.data.authorised_modules.replace(' ','').split(',') : [];
          if(response.data.authorised_modules.match(response.data.last_module)) {
            window.open(`${environment.base_url}/` + response.data.last_module, '_self');
          } else {
            window.open(`${environment.base_url}/` + auth_modules[0], '_self');
          };
        };
        return false;
      } else {
        return true;
      };
    }));
  }

  redirectToLoginPage() {
    window.location.href = environment.base_url + '/account/login';
    // if (environment.login_type === 'local_login') {
    //   this.router.navigate(['login']);
    // } else {
    //   window.location.href = environment.base_url + '/account/login';
    // }
  }
}
